import type { z } from 'zod';
import type { ProjectEntry } from './schema';

export const projects: z.input<typeof ProjectEntry>[] = [
  {
    name: 'Sitelife',
    years: '2019–2024',
    summary:
      'A model-based construction diary, co-founded and built up over five years and used daily on more than sixty construction sites. Progress on site is logged against the BIM, element by element, with a Revit add-in feeding the model.',
    stack: ['Node.js', 'MongoDB', 'AWS', 'APS', 'C# Revit add-in', 'Unity'],
    url: '',
    clientVisible: false,
  },
  {
    name: 'G3DB',
    years: '2025–2026',
    summary:
      'Room-by-room building release for a nuclear plant under decommissioning: every room moves from categorised to decontaminated, cleared and released. An offline 3D viewer and Bluetooth measurement devices feed the record, under a regulated change process.',
    stack: [
      '.NET 10',
      'EF Core',
      'SQL Server',
      'SolidJS PWA',
      'service worker',
      'APS',
      'Bluetooth LE',
    ],
    url: '',
    clientVisible: false,
  },
  {
    name: 'Raumbuch add-in',
    years: '2025–2026',
    summary:
      'A room book to DIN 13080 for hospital design, kept in sync with the Revit model by an add-in written in F#, one code tree for net48 and net8. The rooms are reviewed in an APS viewer with ACC issues alongside.',
    stack: ['F#', 'Elmish.WPF', 'Revit API', 'net48 + net8', 'APS Viewer', 'ACC Issues'],
    url: '',
    clientVisible: false,
  },
  {
    name: 'bim.ag',
    years: '2024–2026',
    summary:
      'A platform for as-built BIM models: clients order a model to a LOIN configuration, surveyors deliver it, and a point cloud against IFC deviation check runs before acceptance.',
    stack: ['Python', 'point clouds', 'IFC', 'Docker', 'Astro', 'SolidJS', 'Cloudflare'],
    url: 'https://bim.ag',
    clientVisible: false,
  },
  {
    name: 'ifcweb.app / informed.build',
    years: '2024–2026',
    summary:
      'IFC in the browser without an upload: models are parsed, rendered and checked client-side, with accounts, storage and sharing on Cloudflare.',
    stack: ['Astro', 'SolidJS', 'three.js', '@thatopen', 'Cloudflare Workers', 'D1', 'R2'],
    url: 'https://ifcweb.app',
    clientVisible: false,
  },
  {
    name: 'RVT Reader',
    years: '2026',
    summary:
      'Opens Revit .rvt and .rfa files in the browser without Revit: file info, the preview image, the element table and reconstructed geometry. The reader behind the Revit station on this page.',
    stack: ['TypeScript', 'phi-ag/rvt', 'binary format work', 'three.js'],
    url: '',
    clientVisible: false,
  },
  {
    name: 'StoryTeller',
    summary:
      'Generates short videos end to end, from script to render, and publishes them to a YouTube channel with metadata and thumbnails, reviewed after upload.',
    stack: ['Node.js', 'TypeScript', 'Anthropic API', 'ffmpeg', 'YouTube Data API', 'Google OAuth'],
    url: '',
    clientVisible: false,
  },
];
